// rc-upload 2.9.4
import upload from './src';

export default upload;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ant-design-vue@1.7.8@ant-design-vue/es/vc-upload/index.js
// module id = null
// module chunks = 